<template>
  <div class="bottom-bar-container">
    <div class="bottom-bar">
      <div class="bottom-bar-left">
        <span class="bold">{{ text }}</span>
        <span class="bottom-bar-term">{{ termLabel }}</span>
      </div>
      <div class="bottom-bar-right" @click="handleAmountChange">
        <span class="bold green">{{ computedAmountValue(amount) }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { computedAmountValue } from "@/shared-helpers/language.helper";

export default defineComponent({
  name: "BottomBar",
  props: {
    text: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
    termLabel: {
      type: String,
      required: true,
    },
  },
  emits: ["change-payment-amount"],
  setup() {
    return { computedAmountValue };
  },
  methods: {
    handleAmountChange() {
      this.$emit("change-payment-amount");
    },
  },
});
</script>

<style scoped>
.bottom-bar-container {
  position: fixed;
  bottom: 16px;
  left: 16px;
  right: 16px;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(8px);
  border-radius: 16px;
}

.bottom-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(120, 120, 120, 0.2);
  border-radius: 16px;
  padding: 12px 16px;
  height: 68px;
  box-sizing: border-box;
}

.bottom-bar-left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}

.bottom-bar-term {
  color: rgba(60, 60, 67, 0.6);
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.23px;
}

.bottom-bar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

span.bold.green {
  color: var(--Primary-Green-1);
}
</style>
